import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InputValueState } from '../channel-text-input/channel-text-input.component';

@Component({
    selector: 'app-dialog-insert-rows',
    templateUrl: './dialog-insert-rows.component.html',
    styleUrls: ['./dialog-insert-rows.component.css'],
    standalone: false,
})
export class DialogInsertRowsComponent {
    rowNumber: number = 0;
    inputState: InputValueState;
    maxNumberRows: number;

    rowsOverMax: boolean = false;
    hasError: boolean = false;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            title: string;
            coord: any;
            maxNumberRows: number;
        },
        private dialogRef: MatDialogRef<DialogInsertRowsComponent>
    ) {
        this.maxNumberRows = data.maxNumberRows;
    }

    close(result: boolean | number) {
        this.dialogRef.close(result);
    }

    onInputChange(event) {
        if (!/^\d+(\.\d+)?$/.test(event.value) || isNaN(Number(event.value))) this.rowNumber = 0;
        if (Number(event.value) > this.maxNumberRows) {
            this.rowsOverMax = true;
            this.rowNumber = this.maxNumberRows;
            return;
        } else {
            this.rowsOverMax = false;
        }
        this.rowNumber = Number(event.value);
    }

    numberValidation(value: string) {
        if (value === null || value === undefined || String(value).trim() === '') {
            return {
                state: InputValueState.error,
                message: 'input.text.errors.REQUIRED',
            };
        } else if (!/^\d+(\.\d+)?$/.test(value) || isNaN(Number(value))) {
            this.hasError = true;
            return {
                state: InputValueState.error,
                message: 'input-text.errors.NOT_NUMBER_TYPE',
            };
        } else if (Number(value) > this.maxNumberRows) {
            this.hasError = true;
            return {
                state: InputValueState.error,
                message: 'input-text.errors.OVER_MAX',
                errorExtraInfo: { maxNumberRows: this.maxNumberRows },
            };
        } else if (Number(value) % 1 != 0) {
            this.hasError = true;
            return {
                state: InputValueState.error,
                message: 'input-text.errors.NOT_INTEGER',
            };
        }

        this.hasError = false;
        return {
            state: InputValueState.init,
            message: '',
        };
    }
}
